import React from "react";
import { View, StyleSheet, Platform, TouchableOpacity } from "react-native";

import Img from "components/img";
import Text from "components/Text";
import { icons } from "assets/icons";
import Shadow from "components/Shadow";
import ImgIcon from "components/imgIcon";

import { sizes, colors, strings } from "assets/constants";
import tinycolor from "tinycolor2";
import { _goToOrganization } from "routers/helper";

const color = colors.organization;
const iconSize = 35;
const iconContainerSize = 55;
const avatarSize = 40;

const employees = [
  icons._employee_01,
  icons._employee_02,
  icons._employee_03,
  icons._employee_04,
  null,
];

const OrganizationCard: React.FC<OrganizationCardT> = ({
  onPress,
  onAddRole,
  onAddEmployee,
  numberOfEmployee,
}) => {
  return (
    <TouchableOpacity
      onPress={_goToOrganization}
      activeOpacity={sizes.tapOpacity}
      style={styles.card}
    >
      <Shadow shadow={{ opacity: 1 }} style={styles.shadowCard}>
        <View style={styles.header}>
          <View style={styles.iconContainer}>
            <ImgIcon size={iconSize} icon={icons._organization} color={color} />
          </View>
          <View style={styles.titleContainer}>
            <Text
              top={5}
              size={"xl"}
              weight="extraBold"
              color={tinycolor(color).darken(9).toString()}
            >
              {strings.organization}
            </Text>
            <Text
              size={"sm"}
              weight="extraBold"
              color={tinycolor(color).lighten(5).toString()}
            >
              {strings.employee_roles_permissions}
            </Text>
          </View>
        </View>

        <View style={styles.avatarsContainer}>
          {employees.map((avatar, key) => {
            return (
              <View
                key={String(key)}
                style={{
                  ...styles.avatarCard,
                  ...(Platform.OS !== "web"
                    ? { left: key * -10 }
                    : { right: key * -10 }),
                }}
              >
                <View style={styles.avatar}>
                  {avatar ? (
                    <Img source={avatar} style={styles.avatarImg} />
                  ) : (
                    numberOfEmployee > 2 && (
                      <Text top={3} size={"lg"} weight="black">
                        +{numberOfEmployee - 1}
                      </Text>
                    )
                  )}
                </View>
              </View>
            );
          })}
        </View>
      </Shadow>
    </TouchableOpacity>
  );
};

export default OrganizationCard;

const styles = StyleSheet.create({
  card: { height: "100%", width: "100%" },

  shadowCard: {
    width: "100%",
    height: "100%",
    paddingHorizontal: sizes.space,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.white,
  },

  header: {
    flex: 1,
    alignItems: "center",
    flexDirection: "row-reverse",
  },

  iconContainer: {
    width: iconContainerSize,
    height: iconContainerSize,
    borderRadius: iconContainerSize,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tinycolor(color).lighten(62).toString(),
  },

  titleContainer: { marginRight: sizes.space },

  avatarsContainer: {
    height: 50,
    width: "100%",
    alignItems: "center",
    flexDirection: "row-reverse",
  },

  avatarCard: {
    overflow: "hidden",
    width: avatarSize,
    height: avatarSize,
    borderRadius: avatarSize / 2,
    borderColor: colors.border,
    borderWidth: 1,
    backgroundColor: colors.white,
  },

  avatar: {
    flex: 1,
    borderWidth: 2,
    borderColor: colors.white,
    alignItems: "center",
    justifyContent: "center",
  },

  avatarImg: {
    width: "100%",
    height: "100%",
    borderRadius: 100,
    backgroundColor: colors.white,
  },
});
